import { render, staticRenderFns } from "./MediaApproval.vue?vue&type=template&id=03e76907&scoped=true&"
import script from "./MediaApproval.vue?vue&type=script&lang=js&"
export * from "./MediaApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e76907",
  null
  
)

export default component.exports